@if (isInitialized) {
  <div id="main-component-wrapper" (click)="clickedOnApp($event)">
    @if (_sharedService.shouldShowTopNav) {
      <app-header></app-header>
    }
    <div id="wrapper" [ngClass]="{'has-header' : _sharedService.shouldShowTopNav, 'has-sidenav' : _sharedService.shouldShowSidebar}">
      @if (_sharedService.shouldShowSidebar) {
        <app-side-nav></app-side-nav>
      }
      <div id="main-wrapper" class="container-fluid" #wrapper>
        <router-outlet></router-outlet>
      </div>
      <app-ngx-popups></app-ngx-popups>
      <ng-template appPopover></ng-template>
      <ng-template appDrawer></ng-template>
    </div>
  </div>
}
